import React, {useEffect} from 'react';
import checkoutBannerImg from '../../utils/assets/checkout/kitten-sitting-on-the-ladder.png';
import BannerSection from '../../shared/components/BannerSection/BannerSection';
import NavegationInfo from '../../shared/components/NavegationInfo/NavegationInfo';
import PaymentInfo from '../components/PaymentInfo/PaymentInfo';
const Checkout = () => {

    const bannerSectionInfo =
    {
       cardTitle: "Now is the time to invest in pets",
       cardButtonText: "",                    
       lengendBackground: checkoutBannerImg
    }

    useEffect(()=>{
        window.scroll(0, 0);
    })
    return (
        <React.Fragment>
           <BannerSection props={bannerSectionInfo}/>
           <NavegationInfo page="Checkout"/>
           <PaymentInfo/>
        </React.Fragment>
    );
};

export default Checkout;
            